import React, { useEffect, useState, Fragment } from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";

import { textForm, textFormDanhGia } from "../utils";

import theme from "../../../theme";
import KPTextform from "../../../components/KPTComponents/KPTextform";
import AnhChanDung from "../../../components/CommonComponents/AnhChanDung";

function MucDanhGiaA0({ error, valueThamDinh, setValuesThamDinh, values, formThamDinh }) {
    // let textFormA0 = [];
    // if (values && values?.entity === 'gv') {
    //     textFormA0 = textFormDanhGia.mucA0.filter(item => item.key == 'giangVien');
    // }
    // if (values && values?.entity === 'gvtg') {
    //     textFormA0 = textFormDanhGia.mucA0.filter(item => item.key == 'giangVienThinhGiang');
    // }
  return (
    <Fragment>
      <Card style={{ width: '100%', marginTop: 16, backgroundColor: 'antiquewhite' }}>
        <CardContent>
        <Typography variant="h6" component="div" marginBottom={2}>
            {'Đánh giá của thẩm định'}
        </Typography>
          <Box display='flex'>
            <Box width='100%'>
              <KPTextform
                component={Box}
                error={error}
                values={valueThamDinh}
                setValues={setValuesThamDinh}
                textForm={formThamDinh?.mucA0 || []}
              />
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Fragment>
  )
  
}

export default MucDanhGiaA0;